module.exports = __webpack_public_path__ + "img/safari-pinned-tab.d7606f63.svg";